// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
@font-face {
  font-family: "GothamBold";
  src: url("/fonts/gothambold_normal_normal.woff2") format("woff2");
  font-weight: 1rem;
  font-style: 1rem;
}
@font-face {
  font-family: "GothamNarrowBook";
  src: url("/fonts/GothamNarrowBook_normal_condensed.woff2") format("woff2");
  font-weight: 1rem;
  font-style: 1rem;
}
.cvx-font-gotham-bold, nav {
  font-family: "GothamBold", Arial, sans-serif;
}

.cvx-fon-narrow-bold {
  font-family: "GothamNarrowBold", Arial, sans-serif;
}

.cvx-font-gotham-narrow-book {
  font-family: "GothamNarrowBook", Arial, sans-serif;
}

.cvx-gothan-medium {
  font-family: "GothamMedium", Arial, sans-serif;
}

/*font-szes*/
.extraLarge {
  font-size: 1.75rem;
  /*28px*/
}

.large2 {
  font-size: 1.375rem;
  /*22px*/
}

.large {
  font-size: 1.125rem;
  /*18px*/
}

.normal {
  font-size: 1rem;
  /*16px*/
}

.medium {
  font-size: 0.875rem;
  /*14px*/
}

.small {
  font-size: 0.75rem;
  /*12px*/
}

nav {
  z-index: 99;
  width: 100%;
  background: #0b2d71;
}

nav .cvx-navbar-wrapper {
  position: relative;
  height: 45px;
  margin: auto;
  display: flex;
  align-items: center;
  justify-content: center;
}

.cvx-navbar-wrapper .cvx-navbar-nav-links {
  display: flex;
  padding: 0;
  margin: 0;
  height: 100%;
}

.cvx-navbar-nav-links li {
  list-style: none;
  padding: 0;
  margin: 0;
  height: 100%;
  display: flex;
  align-items: center;
}

.cvx-navbar-nav-links li a {
  color: #ffffff;
  text-decoration: none;
  font-size: 14px;
  font-weight: 500;
  padding: 1rem 2rem 1rem 2rem;
  height: 100%;
  display: flex;
  align-items: center;
}

.cvx-navbar-nav-links li a:hover {
  background: #0066b2;
}

.cvx-navbar-nav-links .cvx-navbar-mobile-item {
  display: none;
}

.cvx-navbar-nav-links .cvx-navbar-drop-menu {
  margin: 0;
  padding: 0;
  position: absolute;
  background: #0066b2;
  width: auto;
  line-height: 45px;
  top: 85px;
  opacity: 0;
  visibility: hidden;
  box-shadow: 0 6px 10px rgba(0, 0, 0, 0.15);
  z-index: 99999999;
}

.cvx-navbar-nav-links li:hover .cvx-navbar-drop-menu,
.cvx-navbar-nav-links li:hover .cvx-navbar-mega-box {
  top: 45px;
  opacity: 1;
  visibility: visible;
}

.cvx-navbar-drop-menu li a {
  width: 100%;
  display: block;
  padding: 10px;
  font-weight: 400;
  border-radius: 0px;
}

.cvx-navbar-drop-menu li a:hover {
  background: #0b2d71;
}

.cvx-navbar-content .cvx-navbar-row img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.cvx-navbar-content .cvx-navbar-row header {
  color: #dbdcdd;
  font-size: 16px;
  font-weight: 500;
}

.cvx-navbar-wrapper .cvx-navbar-btn {
  color: #ffffff;
  font-size: 20px;
  cursor: pointer;
  display: none;
}

.cvx-navbar-wrapper .cvx-navbar-btn.cvx-navbar-close-btn {
  position: absolute;
  right: 30px;
  top: 10px;
}

nav input {
  display: none;
}

.cvx-navbar-body-text {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  text-align: center;
  padding: 0 30px;
}

.cvx-navbar-body-text div {
  font-size: 45px;
  font-weight: 600;
}

.cvx-navbar-disabled-link {
  pointer-events: none; /* Deshabilita la interacción */
  cursor: default; /* Cambia el cursor a su estado por defecto */
  color: inherit; /* Mantiene el color del enlace */
  text-decoration: none; /* Opcional: elimina el subrayado */
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/cvx-navbar/cvx-navbar.component.scss","webpack://./src/styles/fonts.scss","webpack://./src/styles/colors.scss"],"names":[],"mappings":"AAAA,gBAAgB;ACQhB;EACE,yBAAA;EACA,iEAAA;EACA,iBAPO;EAQP,gBARO;ADET;ACSA;EACE,+BAAA;EACA,0EAAA;EACA,iBAdO;EAeP,gBAfO;ADQT;ACUA;EACE,4CAAA;ADRF;;ACWA;EACE,kDAAA;ADRF;;ACWA;EACE,kDAAA;ADRF;;ACWA;EACE,8CAAA;ADRF;;ACYA,YAAA;AACA;EACE,kBAxCW;EAyCX,OAAA;ADTF;;ACYA;EACE,mBA5CO;EA6CP,OAAA;ADTF;;ACYA;EACE,mBAhDM;EAiDN,OAAA;ADTF;;ACYA;EACE,eApDO;EAqDP,OAAA;ADTF;;ACYA;EACE,mBAxDO;EAyDP,OAAA;ADTF;;ACYA;EACE,kBA5DM;EA6DN,OAAA;ADTF;;AAnDA;EAEI,WAAA;EACA,WAAA;EACA,mBEXQ;AFgEZ;;AAlDA;EACI,kBAAA;EACA,YAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAqDJ;;AAlDA;EACI,aAAA;EACA,UAAA;EACA,SAAA;EACA,YAAA;AAqDJ;;AAlDA;EACI,gBAAA;EACA,UAAA;EACA,SAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;AAqDJ;;AAlDA;EACI,cEZI;EFaJ,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,4BAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;AAqDJ;;AAlDA;EACI,mBElDU;AFuGd;;AAlDA;EACI,aAAA;AAqDJ;;AAlDA;EACI,SAAA;EACA,UAAA;EACA,kBAAA;EACA,mBE7DU;EF8DV,WAAA;EACA,iBAAA;EACA,SAAA;EACA,UAAA;EACA,kBAAA;EACA,0CAAA;EACA,iBAAA;AAqDJ;;AAlDA;;EAEI,SAAA;EACA,UAAA;EACA,mBAAA;AAqDJ;;AAlDA;EACI,WAAA;EACA,cAAA;EACA,aAAA;EACA,gBAAA;EACA,kBAAA;AAqDJ;;AAlDA;EACI,mBExFQ;AF6IZ;;AAlDA;EACI,WAAA;EACA,YAAA;EACA,iBAAA;AAqDJ;;AAlDA;EACI,cE5ES;EF6ET,eAAA;EACA,gBAAA;AAqDJ;;AAlDA;EACI,cE5EI;EF6EJ,eAAA;EACA,eAAA;EACA,aAAA;AAqDJ;;AAlDA;EACI,kBAAA;EACA,WAAA;EACA,SAAA;AAqDJ;;AAlDA;EACI,aAAA;AAqDJ;;AAlDA;EACI,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,WAAA;EACA,kBAAA;EACA,eAAA;AAqDJ;;AAlDA;EACI,eAAA;EACA,gBAAA;AAqDJ;;AAlDA;EACI,oBAAA,EAAA,+BAAA;EACA,eAAA,EAAA,6CAAA;EACA,cAAA,EAAA,iCAAA;EACA,qBAAA,EAAA,mCAAA;AAqDJ","sourcesContent":["// --ORIGINAL CODE--------------------------------------------------------\n// https://codepen.io/fadzrinmadu/pen/bGqrJjB\n// -----------------------------------------------------------------------\n\n@use '../../../../styles/fonts' as *;\n@use '../../../../styles/colors' as colors;\n\nnav {\n    @extend .cvx-font-gotham-bold;\n    z-index: 99;\n    width: 100%;\n    background: colors.$dark-blue;\n}\n\nnav .cvx-navbar-wrapper {\n    position: relative;\n    height: 45px;\n    margin: auto;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.cvx-navbar-wrapper .cvx-navbar-nav-links {\n    display: flex;\n    padding:0;\n    margin:0;\n    height: 100%;\n}\n\n.cvx-navbar-nav-links li {\n    list-style: none;\n    padding:0;\n    margin:0;\n    height:100%;\n    display: flex;\n    align-items: center;\n}\n\n.cvx-navbar-nav-links li a {\n    color: colors.$white;\n    text-decoration: none;\n    font-size: 14px;\n    font-weight: 500;\n    padding: 1rem 2rem 1rem 2rem;\n    height: 100%;\n    display: flex;\n    align-items: center;\n}\n\n.cvx-navbar-nav-links li a:hover {\n    background: colors.$medium-blue; // #3a3b3c;\n}\n\n.cvx-navbar-nav-links .cvx-navbar-mobile-item {\n    display: none;\n}\n\n.cvx-navbar-nav-links .cvx-navbar-drop-menu {\n    margin: 0;\n    padding: 0;\n    position: absolute;\n    background: colors.$medium-blue; // #242526;\n    width: auto;\n    line-height: 45px;\n    top: 85px;\n    opacity: 0;\n    visibility: hidden;\n    box-shadow: 0 6px 10px rgba(0, 0, 0, 0.15);\n    z-index: 99999999;\n}\n\n.cvx-navbar-nav-links li:hover .cvx-navbar-drop-menu,\n.cvx-navbar-nav-links li:hover .cvx-navbar-mega-box {\n    top: 45px;\n    opacity: 1;\n    visibility: visible;\n}\n\n.cvx-navbar-drop-menu li a {\n    width: 100%;\n    display: block;\n    padding: 10px;\n    font-weight: 400;\n    border-radius: 0px;\n}\n\n.cvx-navbar-drop-menu li a:hover {\n    background: colors.$dark-blue;\n}\n\n.cvx-navbar-content .cvx-navbar-row img {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n}\n\n.cvx-navbar-content .cvx-navbar-row header {\n    color: colors.$light-gray;\n    font-size: 16px;\n    font-weight: 500;\n}\n\n.cvx-navbar-wrapper .cvx-navbar-btn {\n    color: colors.$white;\n    font-size: 20px;\n    cursor: pointer;\n    display: none;\n}\n\n.cvx-navbar-wrapper .cvx-navbar-btn.cvx-navbar-close-btn {\n    position: absolute;\n    right: 30px;\n    top: 10px;\n}\n\nnav input {\n    display: none;\n}\n\n.cvx-navbar-body-text {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    width: 100%;\n    text-align: center;\n    padding: 0 30px;\n}\n\n.cvx-navbar-body-text div {\n    font-size: 45px;\n    font-weight: 600;\n}\n\n.cvx-navbar-disabled-link {\n    pointer-events: none; /* Deshabilita la interacción */\n    cursor: default; /* Cambia el cursor a su estado por defecto */\n    color: inherit; /* Mantiene el color del enlace */\n    text-decoration: none; /* Opcional: elimina el subrayado */\n}\n","// FONTS\n$extraLarge: 1.75rem; // 28pt\n$large2: 1.375rem; // 22pt\n$large: 1.125rem; // 18pt\n$normal: 1rem; // 16pt\n$medium: 0.875rem; // 14pt\n$small: 0.75rem; // 12pt\n\n@font-face {\n  font-family: \"GothamBold\";\n  src: url(\"/fonts/gothambold_normal_normal.woff2\") format(\"woff2\");\n  font-weight: $normal;\n  font-style: $normal;\n}\n\n@font-face {\n  font-family: \"GothamNarrowBook\";\n  src: url(\"/fonts/GothamNarrowBook_normal_condensed.woff2\") format(\"woff2\");\n  font-weight: $normal;\n  font-style: $normal;\n}\n\n.cvx-font-gotham-bold {\n  font-family: \"GothamBold\", Arial, sans-serif;\n}\n\n.cvx-fon-narrow-bold {\n  font-family: \"GothamNarrowBold\", Arial, sans-serif;\n}\n\n.cvx-font-gotham-narrow-book {\n  font-family: \"GothamNarrowBook\", Arial, sans-serif;\n}\n\n.cvx-gothan-medium {\n  font-family: \"GothamMedium\", Arial, sans-serif;\n}\n\n\n/*font-szes*/\n.extraLarge {\n  font-size: $extraLarge;\n  /*28px*/\n}\n\n.large2 {\n  font-size: $large2;\n  /*22px*/\n}\n\n.large {\n  font-size: $large;\n  /*18px*/\n}\n\n.normal {\n  font-size: $normal;\n  /*16px*/\n}\n\n.medium {\n  font-size: $medium;\n  /*14px*/\n}\n\n.small {\n  font-size: $small;\n  /*12px*/\n}","$dark-blue: #0b2d71;\n$medium-blue: #0066b2;\n$light-blue: #009dd9;\n$dark-teal: #003653;\n$medium-teal: #00708c;\n$light-teal: #00b2bd;\n$dark-green: #444b0d;\n$medium-green: #769231;\n$light-green: #b2cc34;\n$dark-orange: #711b00;\n$medium-orange: #e5601f;\n$light-orange: #faab18;\n$dark-red: #58001c;\n$medium-red: #97002e;\n$light-red: #e21836;\n$lighter-red: rgb(247, 235, 239);\n$dark-purple: #3a0d36;\n$medium-purple: #751269;\n$light-purple: #ba3093;\n\n$dark-gray: #6b6d6f;\n$medium-gray: #8c8f93;\n$light-gray: #dbdcdd;\n$lighter-gray: #ECECEC;\n$lightest-gray: #f7f7f7; //alternative background-gray\n$lightest-gray2: #f3f3f3;\n\n$black: #000000;\n$white: #ffffff;\n$background-gray: #ededee;\n\n$highlight-blue: #E4F4FA; // for table highlights only\n$lighter-blue: #E4ECF2;\n$primary-blue: #007bff;\n$highlight-yellow: #E3F1A2;\n$highlight-peach: #FFE594;\n$highlight-neon: #FFA4C0;\n$success: #00708c;\n$warning: #faab18;\n$error: #97002e;"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
